export type EditCourseMetadataProps = unknown

export enum EditCourseMetadataTab {
    prettyNameAndAbbreviation = 'Pretty Name and Abbreviation',
    nextSittingDate = 'Next Sitting Date',
    recommendedStudyHours = 'Recommended Study Hours',
    contentTierTitles = 'Content Tier Titles',
    releaseInfo = 'Release Info',
    featureFlags = 'Feature Flags',
}
